const formatSlideValues = (heading, value) => {
  if (!Array.isArray(value) || value.length === 0) return '';

  const formattedItems = value
    .map((item) => {
      if (typeof item === 'object' && 'checked' in item) {
        return item.checked ? ` - ${item.value}` : null;
      }
      return ` - ${item}`;
    })
    .filter(Boolean)
    .join('\n');
  return formattedItems ? `${heading}\n${formattedItems}` : '';
};

const formatSingleValue = (heading, value) => {
  if (!value) return '';

  const isRangeSliderValue = !isNaN(value);

  if (isRangeSliderValue) {
    return `${heading}\n- Du angav: "${value} av 10"`;
  }

  const valueWithNewlineFormatting = value
    ?.split('\n')
    .map((line) => (line.trim() ? ` - ${line.trim()}` : ''))
    .join('\n');

  return valueWithNewlineFormatting
    ? `${heading}\n${valueWithNewlineFormatting}`
    : '';
};

export const formatLetterData = (data) => {
  if (!data || typeof data !== 'object') return '';

  const formattedEntries = Object.entries(data)
    .map(([, { heading, value }]) =>
      Array.isArray(value)
        ? formatSlideValues(heading, value)
        : formatSingleValue(heading, value)
    )
    .filter(Boolean)
    .join('\n\n');

  return formattedEntries.trim();
};
